/**
 * Entra ID (Azure AD) configuration for the adopted Omni ITM frontend.
 *
 * Ported from apps/frontend/src-legacy/auth/config.ts — the adopted app
 * previously ran on session-cookie auth (OmniBeta backend). Omni Cloud uses
 * MSAL browser auth + Bearer tokens, so this file replaces the beta's
 * `/auth/logout` redirect model entirely.
 */

export const legacyEntraDefaults = {
  tenantId: "e36a2120-7390-49f9-b9a3-95c4d80c1ba1",
  clientId: "35854a87-0615-408d-abb3-f6765701a7e7",
  adminRole: "DriveMapAdmin",
  readerRole: "DriveMapReader"
};

function withLeadingSlash(value) {
  if (!value) return "/";
  return value.startsWith("/") ? value : `/${value}`;
}

export const entraConfig = {
  tenantId: import.meta.env.VITE_ENTRA_TENANT_ID ?? legacyEntraDefaults.tenantId,
  clientId: import.meta.env.VITE_ENTRA_CLIENT_ID ?? legacyEntraDefaults.clientId,
  adminRole: import.meta.env.VITE_ENTRA_ADMIN_ROLE ?? legacyEntraDefaults.adminRole,
  readerRole: import.meta.env.VITE_ENTRA_READER_ROLE ?? legacyEntraDefaults.readerRole,
  redirectPath: withLeadingSlash(import.meta.env.VITE_ENTRA_REDIRECT_PATH ?? "/login"),
  postLogoutRedirectPath: withLeadingSlash(import.meta.env.VITE_ENTRA_POST_LOGOUT_REDIRECT_PATH ?? "/login")
};

export const authRuntimeConfig = {
  enabled: (import.meta.env.VITE_AUTH_ENABLED ?? "true").trim().toLowerCase() !== "false"
};

export function buildAuthorityUrl(tenantId) {
  return `https://login.microsoftonline.com/${tenantId}`;
}

/**
 * API base URL resolution — mirrors src-legacy/App.tsx exactly so SWA
 * deploys keep working (the SWA build injects VITE_API_BASE_URL at build
 * time via the GitHub Actions workflow).
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "http://localhost:4000";

/** Scopes requested for the API access token (App Registration exposes this API scope). */
export const apiTokenRequest = {
  scopes: [import.meta.env.VITE_ENTRA_API_SCOPE ?? `api://${entraConfig.clientId}/access_as_user`]
};
